var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"straitigraphy-tab"},[_c('button',{staticClass:"button primary",on:{"click":function($event){return _vm.goToStraitigraphy()}}},[_vm._v("\n\t\tStraitigraphy\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }